'use client';

import React, { memo, useEffect, useState } from 'react';
import { MODALS } from '../../../util/constants';
import getStrapiModalInfo from '../../../util/getStrapiModalInfo';
import SweeprActionModal from '../../shared/sweepr-action-modal/SweeprActionModal';
import AccountVerificationContainer from './AccountVerificationContainer';

const { ACCOUNT_VERIFICATION } = MODALS;

/**
 * @name AccountVerificationModal
 * @description - Account Verification modal component
 * @param {boolean} showAccountVerificationModal - Toggle's the login verification modal
 * @returns {JSX.Element} Account Verification Modal
 */
const AccountVerificationModal = ({
  showAccountVerificationModal,
  handleAction,
  disableCTA,
  setDisableCTA,
  apiError,
  values,
  setValues,
  setCaptchaV2,
  enableCaptchaV2,
  captchaV2,
  errorCount,
  maxErrorCount,
}) => {
  const [cmsData, setCmsData] = useState(null);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    /**
     * @name getCmsData
     * @description Fetches data from the Strapi API
     * @returns {Promise<void>} Promise and sets the state cmsData when resolved
     */
    const getCmsData = async () => {
      const data = await getStrapiModalInfo(ACCOUNT_VERIFICATION);
      setCmsData(data);
    };

    setLoad(false);
    getCmsData();
  }, []);

  return (
    <SweeprActionModal
      id={cmsData?.attributes?.modalID}
      open={showAccountVerificationModal?.value}
      handleClose={showAccountVerificationModal?.disable}
      iconSrc={errorCount > 0 && cmsData?.attributes?.iconSrc?.data?.attributes?.url}
      handleBack={showAccountVerificationModal?.disable}
      title={errorCount === 0 && cmsData?.attributes?.title}
      description={
        <>
          {errorCount === 0 && cmsData?.attributes?.firstHalfDescription}
          <AccountVerificationContainer
            setDisableCTA={setDisableCTA}
            disableCTA={disableCTA}
            values={values}
            setValues={setValues}
            setCaptchaV2={setCaptchaV2}
            enableCaptchaV2={enableCaptchaV2}
            captchaV2={captchaV2}
            apiError={apiError}
            errorCount={errorCount}
            maxErrorCount={maxErrorCount}
            handleAction={handleAction}
          />
        </>
      }
      load={load}
      cta={errorCount === 0 && cmsData?.attributes?.cta}
      disablecta={disableCTA}
      handleAction={handleAction}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disclaimer={errorCount === 0 && cmsData?.attributes?.disclaimer}
    />
  );
};

AccountVerificationModal.displayName = 'AccountVerificationModal';
export default memo(AccountVerificationModal);
